import React, { memo } from 'react';
import { CartButtonView } from './CartButton.view';
import { getPanierProductsCount } from 'store/selectors/panier/panier.selectors';
import { useSelector } from 'react-redux';
import pages from 'routes/pages';
import { useLocation, useParams } from 'react-router-dom';
import useGoToPage from 'hooks/useGoToPage';
import { useMediaQuery } from 'hooks/useMediaQuery';

export interface CartButtonProps {
  shopId?: string | null;
  helpText?: string;
}

const CartButton = memo(({ shopId = null, helpText }: CartButtonProps) => {
  const { classeId } = useParams<{ classeId: string }>();

  const toPublicShopPanier = useGoToPage(pages.PUBLIC_SHOP_PANIER.path, {
    shopId: shopId,
    classeId: classeId
  });
  const toPanier = useGoToPage(pages.PANIER_PAGE.path);
  const isTablet = useMediaQuery('tablet');
  const location = useLocation();
  const numberOfArticles = useSelector(getPanierProductsCount);

  return (
    <>
      <CartButtonView
        helpText={helpText}
        onClick={shopId ? toPublicShopPanier : toPanier}
        numberOfArticles={numberOfArticles}
        isMobile={isTablet}
        location={location}
      />
    </>
  );
});

export default CartButton;

CartButton.displayName = 'CartButton';
